import {FormNavigation} from "./FormNavigation";
import {RefObject} from "react";
import FormNavigationCard from "./FormNavigationCard";

import "./FormNavigation.css"

/**
 * The props for this component
 */
interface FormNavigationCardProps {
  parentFormContainer: RefObject<HTMLDivElement | HTMLFormElement>;
  listOfPanels: FormNavigation[];
}

/**
 * This component creates a navigation panel for a form.
 * It provides us with buttons to allow for easier navigation between panels inside our form.
 *
 * @param parentFormContainer The {@link RefObject} for the {@code Form} or {@code Div} that contains your panels.
 *  It needs to be scrollable.
 * @param listOfPanels This is a list of {@link FormNavigation} elements. This list will be used to populate the panel
 */
export default function FormNavigationPanel({
                                              parentFormContainer,
                                              listOfPanels
                                            }: FormNavigationCardProps) {
  return <div id={`formNavigationPanel${parentFormContainer.current?.id}`}
              className={"form-navigation"}>
    {listOfPanels.map((panel, index) => (
        <FormNavigationCard label={panel.label}
                            formContainerRef={parentFormContainer}
                            targetPanelRef={panel.panelReference}
                            key={`nav-card-${index}`}/>
    ))}
  </div>
}